// src/api/axiosInstance.js

import axios from 'axios';

const BASE_URL = window.BASE_URL;
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token; // ✅ using plain string concat
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
